import { BooleanField, Datagrid, DateField, List, Pagination, TextField, TextInput } from "react-admin";

const Pagination100 = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />;

const filters = [<TextInput label="Domain" source="domain" alwaysOn />]
export function EmailDomainList() {
    return (
        <List perPage={25}
            pagination={<Pagination100 />}
            filters={filters}
            exporter={false}
        >
            <Datagrid rowClick="edit">
                <TextField source="id" label={"Domain"} />
                <BooleanField source="isDisposable" />
                <DateField source="createdAt" />
                <DateField source="updatedAt" />
            </Datagrid>
        </List>
    )

}

